import React from 'react';
import './NavigationControls.css';

interface NavigationControlsProps {
  currentIndex: number;
  totalSteps: number;
  isPlaying: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onPlayPause: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
  playbackSpeed?: number;
  onSpeedChange?: () => void;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  currentIndex,
  totalSteps,
  isPlaying,
  onPrevious,
  onNext,
  onPlayPause,
  canGoPrevious,
  canGoNext,
  playbackSpeed = 1,
  onSpeedChange,
}) => {
  return (
    <div className="navigation-controls">
      <button
        className="nav-button"
        onClick={onPrevious}
        disabled={!canGoPrevious}
        title="Previous (Left Arrow)"
      >
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path
            d="M12 5l-5 5 5 5"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      </button>

      <button
        className="nav-button play-pause play-pause-btn"
        onClick={onPlayPause}
        title={isPlaying ? 'Pause (Space)' : 'Play (Space)'}
      >
        {isPlaying ? (
          <svg width="20" height="20" viewBox="0 0 20 20">
            <rect x="5" y="4" width="4" height="12" fill="currentColor" />
            <rect x="11" y="4" width="4" height="12" fill="currentColor" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 20 20">
            <path d="M6 4l10 6-10 6z" fill="currentColor" />
          </svg>
        )}
      </button>

      <button
        className="nav-button"
        onClick={onNext}
        disabled={!canGoNext}
        title="Next (Right Arrow)"
      >
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path
            d="M8 5l5 5-5 5"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      </button>

      <div className="step-info">
        <span className="current-step">{currentIndex + 1}</span>
        <span className="separator">/</span>
        <span className="total-steps">{totalSteps}</span>
      </div>

      {onSpeedChange && (
        <button
          className="nav-button speed-control speed-selector"
          onClick={onSpeedChange}
          title="Change playback speed"
        >
          <span className="speed-text">{playbackSpeed}x</span>
        </button>
      )}
    </div>
  );
};

export default NavigationControls;